/* GK Flash Deal Countdowns — PLP + inherited PDP */
(function(){
'use strict';var STYLE_ID='gk-flash-deal-styles',timer=null,scheduled=false,pdpLoaded=false,pdpCampaigns=[];
function ensureStyles(){var old=document.getElementById(STYLE_ID);if(old)old.remove();var s=document.createElement('style');s.id=STYLE_ID;s.textContent=['.product-item__image-wrapper{position:relative}','.gk-flash-countdown{box-sizing:border-box!important;font-variant-numeric:tabular-nums;text-transform:uppercase;font-weight:700;letter-spacing:.035em;line-height:1;pointer-events:none!important}','.product-item__image-wrapper>.gk-flash-countdown{position:absolute!important;left:0!important;top:0!important;right:0!important;transform:none!important;width:100%!important;z-index:3!important}','.gk-flash-countdown__inner{box-sizing:border-box!important;display:flex;align-items:center;justify-content:center;gap:12px;min-height:44px;padding:0 12px;white-space:nowrap}','.gk-flash-countdown__text{font-size:13px;white-space:nowrap}','.gk-flash-countdown__time{font-size:14px;white-space:nowrap}','.gk-flash-pdp-desktop-slot{display:flex;justify-content:flex-start}','.gk-flash-pdp-desktop-slot .gk-flash-countdown{display:inline-block!important;width:auto!important;max-width:100%!important;margin:0 0 14px!important;border-radius:2px}','.gk-flash-pdp-desktop-slot .gk-flash-countdown__inner{min-height:32px;padding:0 13px;gap:8px}','.gk-flash-pdp-desktop-slot .gk-flash-countdown__text{font-size:10px}','.gk-flash-pdp-desktop-slot .gk-flash-countdown__time{font-size:11px}','.gk-flash-pdp-mobile-slot{display:none}','@media(max-width:740px){.product-item__image-wrapper>.gk-flash-countdown{left:0!important;right:0!important;top:0!important;width:100%!important;transform:none!important}.product-item__image-wrapper>.gk-flash-countdown .gk-flash-countdown__inner{min-height:22px!important;gap:4px!important;padding:0 5px!important}.product-item__image-wrapper>.gk-flash-countdown .gk-flash-countdown__text{font-size:8px!important}.product-item__image-wrapper>.gk-flash-countdown .gk-flash-countdown__time{font-size:9px!important}.gk-flash-pdp-desktop-slot{display:none!important}.gk-flash-pdp-mobile-slot{display:block!important;width:calc(100% + 48px)!important;max-width:none!important;margin-left:-24px!important;margin-right:-24px!important;margin-bottom:-8px!important}.gk-flash-pdp-mobile-slot .gk-flash-countdown{display:block!important;width:100%!important;margin:0!important;border-radius:0!important}.gk-flash-pdp-mobile-slot .gk-flash-countdown__inner{width:100%!important;min-height:34px;gap:8px}.gk-flash-pdp-mobile-slot .gk-flash-countdown__text{font-size:11px!important}.gk-flash-pdp-mobile-slot .gk-flash-countdown__time{font-size:12px!important}}'].join('');document.head.appendChild(s);}
function handle(){var p=location.pathname.split('/').filter(Boolean),i=p.indexOf('collections');return i>=0&&p[i+1]?p[i+1]:'';}
function parse(root){
  var r=[];
  root=root||document;

  root.querySelectorAll('[data-gk-flash-campaigns]').forEach(function(n){
    try{
      var campaigns=JSON.parse(n.textContent||'[]');
      if(Array.isArray(campaigns)){
        campaigns.forEach(function(c){
          if(c&&c.target_type)r.push(c);
        });
      }
    }catch(e){}
  });

  return r;
}
function end(c){
  if(!c || !c.end_date) return null;

  var d = String(c.end_date).split('-');
  var t = String(c.end_time || '23:59:59').split(':');

  if(d.length !== 3) return null;

  var y  = +d[0];
  var mo = +d[1];
  var da = +d[2];
  var h  = +(t[0] || 0);
  var mi = +(t[1] || 0);
  var s  = +(t[2] || 0);

  /*
   * The campaign date/time is always interpreted
   * in the Europe/Lisbon time zone.
   */
  var wanted = Date.UTC(y, mo - 1, da, h, mi, s);

  function partsAt(timestamp) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Lisbon',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date(timestamp));

    var out = {};

    parts.forEach(function(p) {
      if (p.type !== 'literal') out[p.type] = +p.value;
    });

    return out;
  }

  var guess = wanted;

  // Resolve the Lisbon UTC offset for this specific date.
  for (var i = 0; i < 3; i++) {
    var p = partsAt(guess);

    var represented = Date.UTC(
      p.year,
      p.month - 1,
      p.day,
      p.hour,
      p.minute,
      p.second
    );

    guess += wanted - represented;
  }

  var result = new Date(guess);

  return isNaN(result.getTime()) ? null : result;
}function visible(c,where){var scope=c.display_scope||'both';return scope==='both'||scope===where;}
function pick(id,list,h,cols,where){id=String(id||'');var u=list.filter(function(c){return visible(c,where);});var p=u.find(function(c){return c.target_type==='products'&&(c.products||[]).some(function(x){return String(x)===id;});});if(p)return p;return u.find(function(c){if(c.target_type!=='collection')return false;if(where==='collection')return c.collection_handle===h;return (cols||[]).indexOf(c.collection_handle)>=0;})||null;}
function rgba(hex,op){hex=String(hex||'#000000').replace('#','');if(hex.length===3)hex=hex.split('').map(function(x){return x+x;}).join('');var n=parseInt(hex,16);if(isNaN(n))return 'rgba(0,0,0,'+op+')';return 'rgba('+((n>>16)&255)+','+((n>>8)&255)+','+(n&255)+','+op+')';}
function bar(c){var b=document.createElement('div');b.className='gk-flash-countdown';b.dataset.endDate=c.end_date||'';b.dataset.endTime=c.end_time||'23:59:59';var op=Math.max(0,Math.min(100,Number(c.background_opacity==null?100:c.background_opacity)))/100;b.style.backgroundColor=rgba(c.background||'#000000',op);b.style.color=c.text_color||'#fff';b.innerHTML='<div class="gk-flash-countdown__inner"><span class="gk-flash-countdown__text"></span><span class="gk-flash-countdown__time">00:00:00</span></div>';b.querySelector('.gk-flash-countdown__text').textContent=c.text||'FLASH DEAL';return b;}
function tick(){document.querySelectorAll('.gk-flash-countdown').forEach(function(b){var e=end({end_date:b.dataset.endDate,end_time:b.dataset.endTime});if(!e){b.remove();return;}var diff=e-Date.now();if(diff<=0){b.remove();return;}var q=Math.floor(diff/1000),d=Math.floor(q/86400);q%=86400;var h=Math.floor(q/3600);q%=3600;var m=Math.floor(q/60),ss=q%60,p=function(n){return String(n).padStart(2,'0');},clock=p(h)+':'+p(m)+':'+p(ss);b.querySelector('.gk-flash-countdown__time').textContent=d>1?d+'D '+clock:clock;});}
function renderCollection(){var list=parse(document),h=handle();document.querySelectorAll('product-item[data-product-id]').forEach(function(card){var old=card.querySelector('.gk-flash-countdown');if(old)old.remove();var image=card.querySelector(':scope > .product-item__image-wrapper')||card.querySelector('.product-item__image-wrapper');var c=pick(card.dataset.productId,list,h,[],'collection');if(c&&end(c)&&end(c)>Date.now()&&image)image.appendChild(bar(c));});}
function ensurePdpSlots(){var info=document.querySelector('.shopify-section--main-product .product-content-info'),prod=document.querySelector('.shopify-section--main-product .product');if(info&&!info.querySelector('.gk-flash-pdp-desktop-slot')){var d=document.createElement('div');d.className='gk-flash-pdp-desktop-slot';info.insertBefore(d,info.firstChild);}if(prod&&!prod.querySelector('.gk-flash-pdp-mobile-slot')){var m=document.createElement('div');m.className='gk-flash-pdp-mobile-slot';var media=prod.firstElementChild;if(media&&media.nextSibling)prod.insertBefore(m,media.nextSibling);else prod.appendChild(m);}}
function productHandle(){var p=location.pathname.split('/').filter(Boolean),i=p.indexOf('products');return i>=0&&p[i+1]?p[i+1].split('?')[0]:'';}
function renderPdp(id,cols){ensurePdpSlots();document.querySelectorAll('.gk-flash-pdp-desktop-slot .gk-flash-countdown,.gk-flash-pdp-mobile-slot .gk-flash-countdown').forEach(function(x){x.remove();});var c=pick(id,pdpCampaigns,'',cols||[],'product');if(!c||!end(c)||end(c)<=Date.now())return;var d=document.querySelector('.gk-flash-pdp-desktop-slot'),m=document.querySelector('.gk-flash-pdp-mobile-slot');if(d)d.appendChild(bar(c));if(m)m.appendChild(bar(c));}
function loadPdp(){
  var ph=productHandle();

  if(!ph||pdpLoaded)return Promise.resolve();

  return fetch('/products/'+encodeURIComponent(ph)+'.js')
    .then(function(r){
      return r.ok?r.json():null;
    })
    .then(function(prod){
      if(!prod)return;

      pdpCampaigns=parse(document);

      var collectionCampaigns=pdpCampaigns.filter(function(c){
        return c.target_type==='collection' &&
               visible(c,'product') &&
               c.collection_handle;
      });

      var productCampaign=pdpCampaigns.find(function(c){
        return c.target_type==='products' &&
          (c.products||[]).some(function(x){
            return String(x)===String(prod.id);
          });
      });

      if(productCampaign){
        pdpLoaded=true;
        renderPdp(prod.id,[]);
        tick();
        return;
      }

      return Promise.all(
        collectionCampaigns.map(function(c){
          return fetch(
            '/collections/'+encodeURIComponent(c.collection_handle)+
            '/products/'+encodeURIComponent(ph)+'.js'
          )
          .then(function(r){
            return r.ok?c.collection_handle:null;
          })
          .catch(function(){
            return null;
          });
        })
      ).then(function(cols){
        pdpLoaded=true;
        renderPdp(prod.id,cols.filter(Boolean));
        tick();
      });
    })
    .catch(function(){});
}

function render(){ensureStyles();renderCollection();tick();loadPdp();}
function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;render();if(timer)clearInterval(timer);timer=setInterval(tick,1000);});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);else schedule();document.addEventListener('shopify:section:load',schedule);document.addEventListener('shopify:section:select',schedule);
})();